import React from "react";
import PropTypes from "prop-types";
import { Card, Radio } from "@material-tailwind/react";

export default function RichSelectableList({
  items,
  selectedItem,
  onSelect,
  renderSummary,
  renderDetails,
}) {
  return (
    <div className="flex flex-col gap-3 w-full max-w-full whitespace-pre-wrap break-words overflow-x-hidden">
      {items.map((item, index) => {
        const isSelected = selectedItem?.id === item.id;

        return (
          <Card key={`${item.id}-${item.name}-${item.additional_id}`} className={`border rounded max-w-full whitespace-pre-wrap break-words ${isSelected ? "ring-2 text-blue-500" : ""}`}>
            <button
              type="button"
              onClick={() => onSelect(item)}
              className="w-full text-left focus:outline-none"
              aria-pressed={isSelected}
              tabIndex={0}
            >
              <div className="flex items-start gap-3 hover:bg-blue-gray-50 max-w-full whitespace-pre-wrap break-words">
                <Radio
                  name="rich-select"
                  value={item.id}
                  checked={isSelected}
                  onChange={() => onSelect(item)}
                  onClick={(e) => e.stopPropagation()}
                />
                <div className="p-3 w-full">
                  {renderSummary(item)}
                  {renderDetails && (
                    <div className="text-gray-600 mt-1 border-t pt-2 mt-2 border-gray-300 max-w-full whitespace-pre-wrap break-words">
                      {renderDetails(item)}
                    </div>
                  )}
                </div>
              </div>
            </button>
          </Card>
        );
      })}
    </div>
  );
}

RichSelectableList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedItem: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
  renderSummary: PropTypes.func.isRequired,
  renderDetails: PropTypes.func,
}